import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import { ServiceWorkerProvider } from './hooks/useServiceWorker';
import { RecoilRoot } from 'recoil';
import './i18n';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { initializeSentry } from './utils/sentryConfig';
import './index.css';

initializeSentry();

const container = document.getElementById( 'root' );
const root = createRoot( container! );

root.render(
	<React.StrictMode>
		<ServiceWorkerProvider>
			<RecoilRoot>
				<App />
			</RecoilRoot>
		</ServiceWorkerProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
